var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-20 mb-lg-40"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-lg-120px mr-lg-2",
    attrs: {
      "outlined": "",
      "color": "grey"
    },
    on: {
      "click": _vm.goToday
    }
  }, [_c('span', {
    staticClass: "color-grey font-weight-bold tit-txt"
  }, [_vm._v("TODAY")])])], 1), _c('v-col', [_vm.type == 'month' ? _c('calendar-header-month', _vm._g(_vm._b({}, 'calendar-header-month', {
    value: _vm.value
  }, false), {
    input: _vm.input
  })) : _vm._e(), _vm.type == 'week' ? _c('calendar-header-week', _vm._g(_vm._b({}, 'calendar-header-week', {
    value: _vm.value
  }, false), {
    input: _vm.input
  })) : _vm._e(), _vm.type == 'category' ? _c('calendar-header-date', _vm._g(_vm._b({}, 'calendar-header-date', {
    value: _vm.value
  }, false), {
    input: _vm.input
  })) : _vm._e()], 1), _c('v-spacer'), _c('v-col', {
    staticClass: "w-120px w-md-180px",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-select', _vm._g(_vm._b({
    attrs: {
      "value": _vm.type,
      "items": _vm.types,
      "hide-details": "",
      "outlined": ""
    }
  }, 'v-select', _vm.inputAttrs, false), {
    change: _vm.change
  }))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }